var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    id: "Layer_1",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1714_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_292_"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M432.8,506H98.4c-8.3,0-15-6.7-15-15V21c0-8.3,6.7-15,15-15h334.4c8.3,0,15,6.7,15,15v470    C447.9,499.3,441.1,506,432.8,506z",
    fill: "#F45671",
    id: "XMLID_333_"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    height: 469.3,
    id: "XMLID_332_",
    width: 333.8,
    x: 98.7,
    y: 21.3
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_325_"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#E03258",
    id: "XMLID_329_",
    points: "352.4,180.6 64.1,180.6 64.1,64.9 352.4,64.9 288.6,122.8    "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#BC2049",
    id: "XMLID_326_",
    points: "64.1,180.6 83.4,194.9 83.4,180.6    "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_293_"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M402.1,234.4h-273c-4.4,0-8-3.6-8-8v-0.3c0-4.4,3.6-8,8-8h273c4.4,0,8,3.6,8,8v0.3     C410.1,230.8,406.5,234.4,402.1,234.4z",
    fill: "#E03258",
    id: "XMLID_320_"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.1,269.3h-273c-4.4,0-8-3.6-8-8V261c0-4.4,3.6-8,8-8h273c4.4,0,8,3.6,8,8v0.3     C410.1,265.7,406.5,269.3,402.1,269.3z",
    fill: "#E03258",
    id: "XMLID_316_"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.1,304.2h-273c-4.4,0-8-3.6-8-8v-0.3c0-4.4,3.6-8,8-8h273c4.4,0,8,3.6,8,8v0.3     C410.1,300.7,406.5,304.2,402.1,304.2z",
    fill: "#E03258",
    id: "XMLID_310_"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.1,339.2h-273c-4.4,0-8-3.6-8-8v-0.3c0-4.4,3.6-8,8-8h273c4.4,0,8,3.6,8,8v0.3     C410.1,335.6,406.5,339.2,402.1,339.2z",
    fill: "#E03258",
    id: "XMLID_306_"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.1,374.1h-273c-4.4,0-8-3.6-8-8v-0.3c0-4.4,3.6-8,8-8h273c4.4,0,8,3.6,8,8v0.3     C410.1,370.5,406.5,374.1,402.1,374.1z",
    fill: "#E03258",
    id: "XMLID_301_"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.1,409h-273c-4.4,0-8-3.6-8-8v-0.3c0-4.4,3.6-8,8-8h273c4.4,0,8,3.6,8,8v0.3     C410.1,405.5,406.5,409,402.1,409z",
    fill: "#E03258",
    id: "XMLID_297_"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.9,444H129.1c-4.4,0-8-3.6-8-8v-0.3c0-4.4,3.6-8,8-8h207.8c4.4,0,8,3.6,8,8v0.3     C344.9,440.4,341.3,444,336.9,444z",
    fill: "#E03258",
    id: "XMLID_294_"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3175_"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.3,150.3V95.2h18.2c7,0,12.7,2.2,17,6.5c4.4,4.4,6.6,10,6.6,16.8v8.4    c0,6.9-2.2,12.5-6.6,16.8c-4.4,4.3-10.1,6.5-17,6.5H111.3z M120.5,102.6V143h9c4.4,0,7.9-1.5,10.5-4.5c2.6-3,3.9-6.8,3.9-11.5    v-8.4c0-4.6-1.3-8.5-3.9-11.4c-2.6-3-6.1-4.5-10.5-4.5H120.5z",
    fill: "#FFFFFF",
    id: "XMLID_3181_"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.8,127.7c0,6.7-2.1,12.3-6.3,16.7c-4.2,4.4-9.7,6.6-16.5,6.6    c-6.6,0-11.9-2.2-16.1-6.6c-4.1-4.4-6.2-10-6.2-16.7v-9.9c0-6.7,2.1-12.3,6.2-16.7c4.1-4.4,9.5-6.7,16.1-6.7    c6.7,0,12.2,2.2,16.5,6.7c4.2,4.4,6.4,10,6.4,16.7V127.7z M199.6,117.7c0-4.6-1.2-8.4-3.7-11.3c-2.4-3-5.8-4.4-10-4.4    c-4.1,0-7.3,1.5-9.6,4.4c-2.3,3-3.5,6.7-3.5,11.3v10c0,4.6,1.2,8.4,3.5,11.4c2.3,3,5.5,4.4,9.6,4.4c4.2,0,7.5-1.5,10-4.4    c2.4-3,3.7-6.8,3.7-11.4V117.7z",
    fill: "#FFFFFF",
    id: "XMLID_3178_"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.2,132.3l0.1,0.2c0.1,5.6-1.7,10-5.4,13.5c-3.7,3.4-8.7,5.1-15,5.1    c-6.4,0-11.6-2.2-15.6-6.5c-4-4.3-6-9.9-6-16.6v-10.5c0-6.7,2-12.2,5.9-16.6c3.9-4.4,9.1-6.5,15.4-6.5c6.5,0,11.6,1.7,15.3,5    c3.7,3.3,5.5,7.8,5.4,13.6l-0.1,0.2h-8.9c0-3.7-1-6.5-3-8.5c-2-2-4.9-2.9-8.8-2.9c-3.7,0-6.7,1.5-8.9,4.4c-2.2,3-3.3,6.7-3.3,11.2    V128c0,4.6,1.1,8.3,3.3,11.3c2.2,3,5.2,4.4,9.1,4.4c3.8,0,6.6-1,8.6-3c2-2,2.9-4.8,2.9-8.5H261.2z",
    fill: "#FFFFFF",
    id: "XMLID_3176_"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.f81a618ec476bded2b0243fd070f2b98.svg";
export { ForwardRef as ReactComponent };